module.exports = __webpack_public_path__ + "img/WXGZH.f13f5191.jpg";